<template>
    <el-drawer
        title="下载二维码"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <div class="message MT20" v-if="data">
                <div class="imgBox" v-if="data.ticketCodeUrl">
					<img :src="data.ticketCodeUrl" class="img"><br>
					<el-button @click="uploadcode(data.ticketCodeUrl)" type="primary" size="small">下载二维码</el-button>
				</div>
				<div class="imgBox" v-if="data.wechatCodeUrl">
					<img :src="data.wechatCodeUrl" class="img2" ><br>
					<el-button @click="uploadcode(data.wechatCodeUrl)" type="primary" size="small">下载二维码</el-button>
				</div>
            </div>            
        </div>
        <div class="drawer-footer">
            <!-- <el-button @click="close">取消</el-button> -->
            <el-button  @click="close">关闭</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    props:{
        activityId: {
            type: [Number, String],
            default: () => null
        }
    },
    data(){
        return{
            drawerShow:false,
            data:null,
            dataMessage:'',
            dataLoading: false,
			
        }
    },
    mounted(){
        // this.getData();
    },
    methods:{
        show(data){
            this.data = data
            this.drawerShow = true
        },
        close(){
            this.drawerShow = false
        },
		uploadcode(imgUrl){
			const url = imgUrl
			const fileName = this.data.ticketName + '-小程序码.jpg'
			this.$utils.downloadImg(url,fileName);
		},
        
    }
}
</script>

<style lang="scss" scoped>
.imgBox{
    text-align:center;
	.img{		
		width: 300px;
		height:300px
	}
	.img2{
		
		width: 308px;
		height: 360px;
	}
}
</style>